export default () => {
    for (const wrapper of document.querySelectorAll('.share')) {
        const copyBtn = wrapper.querySelector('.share__copy')
        const copyText = wrapper.querySelector('.share__copy-text')
        const announcement = wrapper.querySelector('.share__copy-announcement')

        if (!copyBtn) {
            continue;
        }

        copyBtn.addEventListener('click', () => {
            navigator.clipboard.writeText(window.location.href).then(() => {
                copyBtn.classList.add('share__copy--copied');

                if (copyText) {
                    copyText.textContent = 'Link copied';
                }
                if (announcement) announcement.textContent = 'Link copied to clipboard'


                setTimeout(() => {
                    copyBtn.classList.remove('share__copy--copied');

                    if (copyText) {
                        copyText.textContent = '';
                    }
                    if (announcement) announcement.textContent = ''
                }, 2000)
            })
        })
    }
}
